import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import React, { useState } from "react";
import { FiPlus } from "react-icons/fi";
import { useSearchParams } from "react-router-dom";
import { CustomTable, Modal } from "src/component";
import CustomSearch from "src/component/CustomInput/CustomSearch";
// import { useProtectedRoutesContext } from "src/context/ProtectedRoutes";
import { CreateOrder } from "src/Modal";
import { getAllOrders } from "src/services/api";

const StockOut = () => {
  // const { user } = useProtectedRoutesContext();
  const [searchValue, setSearchValue] = useState("");
  const [searchResults, setSearchResults] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page")) || 1;
  const perPage = parseInt(searchParams.get("per_page")) || 10;

  //   const [inventoryData, setInventoryData] = useState(false);
  const { data, refetch } = useQuery({
    queryKey: ["inventoryItems", searchResults, page, perPage],
    queryFn: () =>
      getAllOrders({
        search: searchResults,
        page: parseInt(searchParams.get("page") ?? 1),
        limit: perPage,
      }),
    suspense: true,
  });

  const columns = [
    {
      name: "S/N",
      cell: (_, i) => i + 1,
      width: "60px",
    },
    {
      name: "Item",
      grow: 2,
      cell: (row) => <div className="capitalize">{row?.inventory_item}</div>,
    },
    // {
    //   name: "Brand",
    //   grow: 2,
    //   cell: (row) => <div className="capitalize">{row?.brand}</div>,
    // },
    {
      name: "Quantity",
      cell: (row) => row?.quantity,
    },
    {
      name: "Date",
      cell: (row) => {
        return row?.created_at
          ? format(new Date(row.created_at), "dd/MM/yyyy")
          : "-";
      },
    },
    {
      name: "Name",
      cell: (row) => row.fullName,
    },
    {
      name: "Email",
      cell: (row) => row.email,
    },
    {
      name: "Order By",
      cell: (row) => row.performed_by,
    },
  ];
  return (
    <div>
      <div className="flex items-center justify-between mb-[3rem]">
        <p className="text-[2.5rem] font-medium text-defaultPrimary">
          Stocks Orders
        </p>
      </div>

      <div className="flex justify-end items-center gap-[3rem]">
        <div className="flex justify-start md:justify-end items-center gap-x-[1rem] flex-wrap">
          <div className="">
            <CustomSearch
              name="name"
              placeholder="Search"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              validate={false}
              formType="fill"
            />
          </div>
          <button
            className="bg-lightPrimary py-[1rem] px-[1.8rem] text-defaultPrimary text-[1.5rem] rounded-lg flex items-center gap-2"
            onClick={() => {
              setSearchResults(searchValue);
            }}
          >
            Search
          </button>
          {searchResults && (
            <button
              className="bg-defaultPrimary py-[1rem] px-[1.8rem] text-white text-[1.5rem] rounded-lg flex items-center gap-2"
              onClick={() => {
                setSearchValue("");
                setSearchResults(null);
              }}
            >
              Reset
            </button>
          )}
        </div>
        {/*  {user?.role === "admin" && ( */}
        <button
          className="bg-lightPrimary py-[1rem] px-[1.8rem] text-defaultPrimary text-[1.5rem] rounded-lg flex items-center gap-2 "
          onClick={() => {
            setModalOpen(true);
          }}
        >
          <FiPlus size={15} />
          Create Order
        </button>
        {/*  )} */}
      </div>
      <CustomTable
        columns={columns}
        data={data?.data?.records}
        paginationTotalRows={data?.data?.pagination?.total}
        paginationPerPage={perPage}
      />
      <Modal isOpen={modalOpen} setIsOpen={setModalOpen} title={"Create Order"}>
        <CreateOrder refetch={refetch} setModalOpen={setModalOpen} />
      </Modal>
    </div>
  );
};

export default StockOut;
